import { render } from "./BlockTools.vue?vue&type=template&id=8b370b6c"
import script from "./BlockTools.vue?vue&type=script&lang=js"
export * from "./BlockTools.vue?vue&type=script&lang=js"
script.render = render

export default script